import {useQuery} from "@tanstack/react-query";
import {getOrdersAdminPortal} from "../services/OrderService";

export function useFittingOrdersAdminPortal(fittingId) {
    const {data, isLoading, isError, error} = useQuery({
        queryKey: ["fittingOrders", fittingId],
        queryFn: () => getOrdersAdminPortal({fittingId}),
        retry: false,
        staleTime: 1000 * 60 * 5,
        enabled: !!fittingId,
    });

    return {
        data,
        isLoading,
        isError,
        error,
    };
}
